import * as React from "react";
import { usePalette } from "react-palette";
import { Box, Text } from "grommet";

import styled from "styled-components";

const Color = styled.span`
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: inline-block;
    background: ${(props) => (props.disabled ? "grey" : props.color)};
    transition: all 0.3s ease;
    box-shadow: 0 0 0 0px ${(props) => props.color};
    input {
        opacity: 0;
        width: 40px;
        height: 40px;
        display: block;
        border: none;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 0 0 2px ${(props) => props.color};
    }
`;

export const ColorPickerWrapper = styled.span`
    width: 120px;
    height: 40px;
    border-radius: 12px;
    display: inline-block;
    transition: all 0.3s ease;
    box-shadow: 0 0 0 0px white;
    border: 1px solid white;
    input {
        opacity: 0;
        width: 120px;
        height: 40px;
        display: block;
        border: none;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 0 0 ${(props) => (props.disabled ? "0px" : "2px")} white;
    }
`;

const ThemeBuilder = ({ uri, color: value, onSelect, disabled }: { uri: string; color: string; onSelect: Function; disabled?: boolean }) => {
    const [color, setColor] = React.useState(value || "#000000");

    const { data, loading, error } = usePalette(uri);

    React.useEffect(() => {
        if (color == "#000000") {
            selectColor(data?.vibrant || "#000000");
        }
    }, [data]);

    const selectColor = (color) => {
        if (!disabled) {
            setColor(color);
            onSelect && onSelect(color);
        }
    };

    return (
        <div>
            <Box gap="small">
                <Box direction="row" align="center" gap="small">
                    <Text>Color</Text>
                    {!loading && !error && (
                        <Box direction="row" gap="small" align="center">
                            <Color disabled={disabled} color={data.vibrant} onClick={() => selectColor(data.vibrant)}></Color>
                            <Color disabled={disabled} color={data.lightVibrant} onClick={() => selectColor(data.lightVibrant)}></Color>
                            <Color disabled={disabled} color={data.darkVibrant} onClick={() => selectColor(data.darkVibrant)}></Color>
                            <Color disabled={disabled} color={data.muted} onClick={() => selectColor(data.muted)}></Color>
                            <Color disabled={disabled} color={data.lightMuted} onClick={() => selectColor(data.lightMuted)}></Color>
                            <Color disabled={disabled} color={data.darkMuted} onClick={() => selectColor(data.darkMuted)}></Color>
                        </Box>
                    )}
                </Box>
                <Box direction="row" align="center">
                    {!loading && !error && <Text>or custom</Text>}
                    <ColorPickerWrapper disabled={disabled} style={{ backgroundColor: color, marginLeft: "10px", border: "2px solid " + getColor(color) }}>
                        <input type="color" value={color} disabled={disabled} onChange={(e) => selectColor(e.target.value)} />
                    </ColorPickerWrapper>
                </Box>
            </Box>
        </div>
    );
};

const getColor = (color) => {
    try {
        return Color.contrast("black", color, "APCA").toString();
    } catch (e) {}
    return color;
};

export const ColorPicker = ({ color, disabled, onChange }: { color: string; disabled?: boolean; onChange: (color: string) => void }) => {
    const [value, setValue] = React.useState(color);

    return (
        <ColorPickerWrapper disabled={disabled} style={{ backgroundColor: value, border: "2px solid " + getColor(value) }}>
            <input type="color" value={value} disabled={disabled} onChange={(e) => setValue(e.target.value)} onBlur={(e) => onChange(value)} />
        </ColorPickerWrapper>
    );
};

export default ThemeBuilder;
